import { HttpClient } from '../HttpClient';
/**
 * * Get Bank Details
 **/

export const GetBankDetails = async () => {
  try {
    const response = await HttpClient.get(
      '/api/instawage/Customers/Me/BankDetails'
    );
    return await Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err);
  }
};
